import { gql } from "@apollo/client"
import { UseQueryOptions, useQuery } from "@oysterhr/core"
import {
  CompensationInsights,
  CompensationInsightsRoleTypesArgs,
  ProvidersEnum,
} from "@oysterhr/schema"

interface GlobalCompensationOptionsPayload {
  compensationInsights: CompensationInsights
}

export const GLOBAL_COMPENSATION_OPTIONS_QUERY = gql`
  query GlobalCompensationOptionsQuery(
    $providerIds: [ProvidersEnum!]!
    $page: Int
    $perPage: Int
    $query: String = ""
  ) {
    compensationInsights {
      roleTypes(providerIds: $providerIds, page: $page, perPage: $perPage, query: $query) {
        collection {
          id
          name
          description
          keywordScore
        }
        metadata {
          currentPage
          totalPages
        }
      }
      supportedCountries(providerIds: $providerIds)
      supportedLevels(providerIds: $providerIds)
    }
  }
`

const useGlobalCompensationOptionsQuery = (
  options?: UseQueryOptions<GlobalCompensationOptionsPayload, CompensationInsightsRoleTypesArgs>,
) => {
  return useQuery<GlobalCompensationOptionsPayload, CompensationInsightsRoleTypesArgs>(
    GLOBAL_COMPENSATION_OPTIONS_QUERY,
    {
      showErrorModal: false,
      ...options,
      variables: {
        page: 1,
        perPage: 20,
        query: "",
        providerIds: [ProvidersEnum.OysterPolicy],
        ...options?.variables,
      },
    },
  )
}

export { useGlobalCompensationOptionsQuery }
